import { RouteType } from "types/RouteType";
import PartnerDetailStore from "./PartnerDetailStore";

/**
 * Partner 360 route — /meeting-partners/:id/:tab?.
 *
 * Hidden, parameterized route (the Partners list owns the nav entry). The route
 * lifecycle drives the store's load + teardown:
 *   - onEnter / onParamsChange → set the id + load the partner (fans out the
 *     email domains + relationship ledger); onEnter also starts following the
 *     ledger live (#3820).
 *   - onExit → dispose() clears the held record and ends the live updates.
 */
const partnerDetailRoute: RouteType[] = [
  {
    name: "PartnerDetail",
    path: "/meeting-partners/:id/:tab?",
    layout: "/app",
    viewportCard: {
      header: {
        enableBackButton: true,
        title: "Partner",
        // Item 26 · There were TWO refresh controls: the library CardHeader's
        // (which re-runs `onEnter`) and a duplicate in the header component
        // (which called `loadPartner()`). At 427px the header overflowed and
        // clipped the route's own — so a phone user saw exactly one refresh and
        // it was the wrong one. The duplicate is gone; `onEnter` below is what
        // this button re-runs, and it loads the partner.
        enableRefreshButton: true,
        component: () => import("./PartnerDetail.Header"),
      },
      body: {
        component: () => import("./PartnerDetail.Body"),
        grayBackground: true,
      },
    },
    group: "Meeting Intelligence",
    hidden: true,
    requiresAuth: true,
    requiresPermission: false,
    onEnter: ({ rootStore, params }) => {
      const store = rootStore.partnerDetailStore as PartnerDetailStore;
      const id = params.id as string;
      if (id) {
        store.setPartnerId(id);
        store.subscribe();
        store.loadPartner();
      }
    },
    onParamsChange: ({ rootStore, params }) => {
      const store = rootStore.partnerDetailStore as PartnerDetailStore;
      const id = params.id as string;
      if (id && store.partnerId !== id) {
        store.setPartnerId(id);
        store.loadPartner();
      }
    },
    onExit: ({ rootStore }) => {
      const store = rootStore.partnerDetailStore as PartnerDetailStore;
      store?.dispose();
    },
    dialogs: [],
  },
];

export default partnerDetailRoute;
